export const TEXT = 'TEXT';
export const IMAGE = 'IMAGE';
export const FRAME = 'FRAME';
export const SCRIPT = 'SCRIPT';
export const XMHT = 'XMHT';
export const XMLFORM = 'XMLFORM';
export const XMLTEST = 'XMLTEST';
export const XMLRESUME = 'XMLRESUME';
export const XMLVCV = 'XMLVCV';

export const DOCTYPE_TESTING_SCORES = 1234;
export const XMLRESUME_CODE = 1193;
export const XMLVCV_CODE = 1197;
